import React, { useContext, useEffect, useState } from "react";
import { NavLink, HashRouter, Route, Switch, Redirect } from "react-router-dom";

import Display_Wallet from "./display_wallet.js";
import Loading_Popup from "./pages/Loading_Popup.js";
import Select_Wallet from "./pages/app_launch/select_wallet.js";
import Wallet_Password from "./pages/app_launch/wallet_password.js";
import Wallet_Unlock from "./pages/app_launch/wallet_unlock.js";
import EnterWalletName from "./pages/app_launch/enter_wallet_name.js";
import Create_New_Wallet from "./pages/app_launch/create_new_wallet.js";
import MenuPanelOptions from './components/MenuPanel/MenuPanelOptions.tsx';
import Restore_Wallet from "./pages/app_launch/restore_wallet_from_seed.js";
import Restore_Wallet_From_File from "./pages/app_launch/restore_wallet_from_file.js";
import { logpath, route_restore_wallet_from_file, route_wallet_unlock } from "./App";
import { UserContext } from "./Contexts/UserContext/UserContext.js";


const Display_Wallet_withlogpath = (props) => {
	return <Display_Wallet logpath={logpath} console={console} />
};

// Guard for wallet-creation/restore routes: if a real (non-mock) wallet is
// already loaded (mnemonic in memory AND isMockWallet is false), redirect
// to /wallet without touching any state. The user must explicitly logout
// (which calls reset_wallet, clearing mnemonic) before these routes become
// accessible. A mock wallet does NOT trigger the guard — the user can still
// access wallet selection/creation routes while browsing the mock wallet.
const useWalletLoadedGuard = () => {
	const userContext = useContext(UserContext)
	return !!(userContext.mnemonic && userContext.isMockWallet !== true)
};

const AppContent = (props) => {
	const isMobile = props.isMobile
	const isMenuOpen = props.isMenuOpen
	let onClickMenuClose = () => { }
	if (props.onClickMenuClose) onClickMenuClose = props.onClickMenuClose

	const walletLoaded = useWalletLoadedGuard()

	const contentStyle = {
		overflowY: "auto",
		// maxHeight: "calc(100vh - 50px)",  // 100vh minus top menu height plus some margin
		// height: "100%",
		height: "100vh",
		overflow: "hidden",
	}

	// First-load splash (Loading_Popup). The hooks must run on every render
	// BEFORE any early return — otherwise opening the mobile menu skips them
	// and, on close, React re-runs them with isLoading reset to true, which
	// re-fired the splash on every mobile navigation. (See TODO.md.)
	// Empty deps: the timer fires once for the lifetime of the component.
	const [isLoading, setIsLoading] = useState(true);
	const [fade, setFade] = useState(false);
	useEffect(() => {
		const timer = setTimeout(() => {
			setFade(true);
			setTimeout(() => setIsLoading(false), 500); // Wait for fade-out before changing page
		}, 1800); // delay before fading starts
		return () => clearTimeout(timer);
	}, []);

	if (isMobile && isMenuOpen) {
		// Allow the whole menu page to scroll when its content (menu list +
		// Close Menu button) exceeds the viewport, e.g. on short screens or
		// when the mobile browser's nav chrome eats into 100vh. The inner
		// .menuSectionContainer also scrolls on its own; this is a safety net
		// so the Close Menu button is never clipped by overflow: hidden.
		const menuContentStyle = {
			...contentStyle,
			overflowY: "auto",
			WebkitOverflowScrolling: "touch",
		};
		return (
			<div className="content" style={menuContentStyle}>
				<MenuPanelOptions onClose={onClickMenuClose} />
				{isMobile ? <><br />
					<div onClick={onClickMenuClose} style={{
						margin: "0 auto",
						width: "fit-content",
					}}>
						<i className="fas fa-times" /> &nbsp; Close Menu
						<div style={{ height: "10vh" }} ></div>
					</div>
				</> : null}
			</div>
		)
	}

	if (isLoading) {
		const loadingContainerStyle = {
			opacity: 1,
			transition: "opacity 0.5s ease", /* duration of the fade */
		}
		if (fade) {
			loadingContainerStyle.opacity = 0
		}
		return (
			<div style={loadingContainerStyle}>
				<Loading_Popup paused={fade} />
			</div>
		)
	}

	return (
		<div className="content" style={contentStyle}>

			{/* <Route exact path="/tests" 	component={Tests}/> */}
			{/* <Route exact path="/" component={Loading_Popup} /> */}

			{/*
				Display_Wallet hosts the /wallet/* inner routes and the home
				slide. It is rendered by a single non-exact catch-all route
				(path ['/', '/home', '/wallet']) placed LAST in the <Switch> so
				that specific top-level routes (select_wallet, create_new_wallet,
				…) match first. This prevents Display_Wallet from remounting when
				navigating between '/', '/home' and '/wallet/*' — remounting
				re-fired the first-load effect (which called reload_wallet) and
				used to wipe the BSV history cache on every return navigation.
				Note: the <Switch> (first-match-wins) is required because a
				non-exact '/' would otherwise prefix-match every path.
			*/}
		<Switch>
			<Route exact path="/select_wallet" render={() =>
				walletLoaded ? <Redirect to="/wallet" push /> : <Select_Wallet />
			} />

			<Route exact path="/create_new_wallet" render={() =>
				walletLoaded ? <Redirect to="/wallet" push /> : <Create_New_Wallet />
			} />

			<Route exact path="/enter_wallet_name" render={() =>
				walletLoaded ? <Redirect to="/wallet" push /> : <EnterWalletName />
			} />

			<Route exact path="/wallet_password" render={() =>
				walletLoaded ? <Redirect to="/wallet" push /> : <Wallet_Password />
			} />

			<Route exact path={route_wallet_unlock} render={() =>
				walletLoaded ? <Redirect to="/wallet" push /> : <Wallet_Unlock />
			} />

			<Route exact path="/restore_wallet" render={() =>
				walletLoaded ? <Redirect to="/wallet" push /> : <Restore_Wallet />
			} />

			<Route exact path={route_restore_wallet_from_file} render={() =>
				walletLoaded ? <Redirect to="/wallet" push /> : <Restore_Wallet_From_File />
			} />

			<Route
				path={['/', '/home', '/wallet']}
				render={Display_Wallet_withlogpath} />

			{/* No top-level 404 needed: the non-exact '/' route above sends all
			    unknown paths to Display_Wallet, whose inner <Switch> has a
			    catch-all <Redirect to="/wallet" />. */}
		</Switch>

		</div>
	)
}


export default AppContent;
